// frontend/src/services/activityService.js
// Admin ▸ Activity (YES-316; call map section 20): counts, times and causes read from the event
// log. No transcript text, codes, model output or uploads reach these screens.
import api from './api';
import { saveFile } from './download';

const enc = encodeURIComponent;
const DAY = 24 * 3600 * 1000;

export const PERIODS = [
    { value: '7d', label: 'Last 7 days', days: 7 },
    { value: '30d', label: 'Last 30 days', days: 30 },
    { value: 'all', label: 'All time', days: null },
];

// The query for a period: from n days ago, to now (open-ended)
export const periodQuery = (value, now = Date.now()) => {
    const days = PERIODS.find((p) => p.value === value)?.days;
    return days ? { from: new Date(now - days * DAY).toISOString() } : {};
};

const clean = (params) => Object.fromEntries(Object.entries(params).filter(([, v]) => v != null && v !== ''));

export const getPeople = async (params) => (await api.get('/api/admin/activity/people', { params: clean(params) })).data;

export const getEvents = async (params) => (await api.get('/api/admin/activity/events', { params: clean(params) })).data;

export const getActions = async () => (await api.get('/api/admin/activity/actions')).data.actions;

export const getPersonSessions = async (userId, params) =>
    (await api.get(`/api/admin/activity/people/${enc(userId)}/sessions`, { params: clean(params) })).data;

// Formatting shared by the Activity screens
export const formatDuration = (ms) => {
    if (ms == null) return '—';
    const minutes = Math.round(ms / 60000);
    if (minutes < 60) return `${minutes} min`;
    return `${Math.floor(minutes / 60)} h ${String(minutes % 60).padStart(2, '0')} min`;
};

export const formatHours = (ms) => (ms == null ? '—' : `${(ms / 3600000).toFixed(1)} h`);

export const formatWhen = (iso, now = new Date()) => {
    if (!iso) return '—';
    const at = new Date(iso);
    const time = at.toLocaleTimeString('en-US', { hour: '2-digit', minute: '2-digit', hour12: false });
    const day = new Date(now);
    day.setHours(0, 0, 0, 0);
    const startOfAt = new Date(at);
    startOfAt.setHours(0, 0, 0, 0);
    const daysAgo = Math.round((day - startOfAt) / (24 * 3600 * 1000));
    if (daysAgo === 0) return `Today ${time}`;
    if (daysAgo === 1) return `Yesterday ${time}`;
    return `${at.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })} ${time}`;
};

const csvCell = (value) => {
    if (value == null) return '';
    const text = String(value);
    return /[",\n]/.test(text) ? `"${text.replace(/"/g, '""')}"` : text;
};

// Download CSV: the rows as shown, built in the browser from what the page already has
export const downloadCsv = (fileName, header, rows) => {
    const body = [header, ...rows].map((row) => row.map(csvCell).join(',')).join('\n');
    saveFile(new Blob([`${body}\n`], { type: 'text/csv' }), fileName);
};
